import React from 'react';
import './SmsPhonePreview.css';

const SmsPhonePreview = ({ message = '' }) => {
    const hasContent = Boolean(message?.trim());

    return (
        <div className="sms-phone-frame">
            <div className="sms-phone-notch" aria-hidden="true" />

            <div className="sms-phone-screen">
                <div className="sms-phone-status-bar">
                    <span className="sms-phone-status-bar__time">9:41</span>
                    <div className="sms-phone-status-bar__icons">
                        <span className="sms-phone-status-bar__signal" aria-hidden="true" />
                        <span className="sms-phone-status-bar__wifi" aria-hidden="true" />
                        <span className="sms-phone-status-bar__battery" aria-hidden="true" />
                    </div>
                </div>

                <div className="sms-phone-header">
                    <span className="sms-phone-header__back">
                        <i className="bi bi-chevron-left" />
                    </span>
                    <div className="sms-phone-header__contact">
                        <span className="sms-phone-header__avatar">
                            <i className="bi bi-building" />
                        </span>
                        <span className="sms-phone-header__name">Your Clinic</span>
                    </div>
                </div>

                <div className="sms-chat-container">
                    <div className={`sms-bubble ${hasContent ? '' : 'is-empty'}`}>
                        {hasContent ? (
                            message.split('\n').map((line, i) => (
                                <div key={i}>{line || '\u00A0'}</div>
                            ))
                        ) : (
                            'Your message preview will appear here…'
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SmsPhonePreview;
